import { GET_TIMELINE_DATA, SET_TIMELINE_DATA } from "../types"

export function getTimelineData(id, openSummary) {
  return { type: GET_TIMELINE_DATA, id, openSummary }
}

export function setTimelineData(data) {
  return { type: SET_TIMELINE_DATA, data }
}
